/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormInstance } from 'antd';
import DropdownIcon from 'assets/icons/simulate_dropdown.svg';
import DropupIcon from 'assets/icons/simulate_dropup.svg';
import LineChartComponent from 'presentation/components/LineChart';
import SimulateDesc from 'presentation/components/SimulateDesc';
import { useCollapse } from 'react-collapsed';
import FormSimulateSale from './FormSimulateSale';

type props = {
    desc: any[];
    detailAssessment: any;
    dataChart: any[];
    form: FormInstance<any>;
    onSubmit: (values: any) => void;
    createClick: () => void;
    btnDisable: boolean;
    setBtnDisable: (value: boolean) => void;
};

const Content = ({
    desc,
    detailAssessment,
    dataChart,
    form,
    onSubmit,
    createClick,
    btnDisable,
    setBtnDisable,
}: props) => {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();

    return (
        <div className="content" id="top-page">
            <div className="content-line-chart">
                <LineChartComponent data={dataChart} legend={true} />
            </div>
            <SimulateDesc lines={desc} />
            <div className="content-collapse">
                <div className="content-collapse__title">入力条件</div>
                <div className="content-collapse__icon" {...getToggleProps()}>
                    <img src={isExpanded ? DropupIcon : DropdownIcon} alt="dropdown icon" />
                </div>
            </div>
            <FormSimulateSale
                form={form}
                detailAssessment={detailAssessment}
                getCollapseProps={getCollapseProps}
                onSubmit={onSubmit}
                createClick={createClick}
                btnDisable={btnDisable}
                setBtnDisable={setBtnDisable}
            />
        </div>
    );
};

export default Content;
